import { useState } from 'react';
import Button from '@/components/Button';
import styles from './FinalScreen.module.css';

export default function FinalScreen({
  mailBody,
  mailtoUrl,
}: {
  mailBody: string;
  mailtoUrl: string;
}) {
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(mailBody);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  }

  return (
    <div className={styles.wrap}>
      <div className={styles.heading}>
        <h1>Danke für deine Auswahl!</h1>
        <p>
          Sende den untenstehenden Text an deine Kontaktperson bei TRO. Der
          Button öffnet deinen Mail-Client direkt mit vorausgefülltem Betreff
          und Inhalt.
        </p>
      </div>

      <pre className={styles.mailBlock}>{mailBody}</pre>

      <div className={styles.actions}>
        <Button onClick={copy}>
          {copied ? 'Kopiert ✓' : 'Text kopieren'}
        </Button>
        <a href={mailtoUrl}>
          <Button>Per Mail an TRO senden</Button>
        </a>
      </div>

      <div className={styles.hint}>
        Die Mailadresse wird automatisch gesetzt, sobald du den Button klickst.
      </div>
    </div>
  );
}
